var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "size",
      class: { "uk-active": _vm.activeSize == this.size.id },
      style: _vm.style,
      on: {
        click: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "prevnet", undefined, $event.key, undefined)
          )
            return null
          _vm.clickable ? _vm.$emit("change", _vm.variation) : null
        },
      },
    },
    [_vm._v(_vm._s(_vm.value))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }